import React, { useState } from 'react';
import * as Sentry from '@sentry/react';
import { toast } from 'react-toastify';
import { useLoading } from '../../context/LoadingContext';
import '../../styles/intake.scss';
import { useTracking } from '../../context/TrackingContext';
import { generateUniqueId, useStateWithSentry } from '../../utilities/common';
import { saveWomTrackingData } from './wom-utilities';

export default function WomReferralFormContainer() {
  const { setIsLoading } = useLoading();
  const [formData] = useStateWithSentry('formData', {});

  const [showIVFDisclaimer, setShowIVFDisclaimer] = useState(false);
  const userTracking = useTracking();

  const handleSubmit = async path => {
    try {
      setIsLoading(true);

      const specificBlobName = generateUniqueId();
      const blobPath = `${import.meta.env.VITE_RAW_FILE_PATH}`;
      const updatedFormdata = { ...formData, ...userTracking, path };

      await saveWomTrackingData({
        formData: updatedFormdata,
        blobPath,
        specificBlobName,
        userTracking,
        path
      });
    } catch (error) {
      console.error('Error during form submission:', error);
      Sentry.captureException(error);
      toast.dismiss();
      toast.error('Sorry, something went wrong on our end. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="wom-form-container">
      {/* -------------------------
           IVF DISCLAIMER PAGE
         ------------------------- */}
      {showIVFDisclaimer ? (
        <div className="ivf-disclaimer-wrapper">
          <div
            className="ivf-disclaimer-box"
            dangerouslySetInnerHTML={{
              __html: `
                <p>Before meeting with an IVF specialist, we do require a referral on file.</p>
                <p>On the next page, you’ll be able to book an appointment with our Nurse Practitioner 
                 Eileen McMahon, who will provide the referral you need.</p>
                <p>After that visit, our team will connect you with the doctor who was recommended to you.</p>
              `
            }}
          />

          <div className="ivf-buttons-row">
            <button
              className="ivf-back-button"
              onClick={() => setShowIVFDisclaimer(false)}
            >
              BACK
            </button>
            <button
              className="ivf-next-button"
              onClick={async () => {
                await handleSubmit('IVF');
              }}
            >
              NEXT
            </button>
          </div>
        </div>
      ) : (
        /* -------------------------
             PAGE 1 — PATH SELECTION
           ------------------------- */
        <div className="d-flex justify-content-center px-3 py-0">
          <div className="text-center w-100" style={{ maxWidth: '700px' }}>
            <h1>
              Please select the fertility path you are most interested in:
            </h1>

            <div className="radio-group d-flex gap-3 flex-wrap">
              <button
                className="btn btn-primary"
                onClick={() => setShowIVFDisclaimer(true)}
              >
                In-Vitro Fertilization (IVF)
              </button>

              <button
                className="btn btn-primary"
                onClick={() => handleSubmit('NCP')}
              >
                Natural Conception Program (NCP)
              </button>

              <button
                className="btn btn-primary"
                onClick={() => handleSubmit('EF')}
              >
                Egg/Embryo Freezing
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
